import moment from "moment";

export const chartLabels = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez"
]

export function fromToDate(monthNumber) {
    return chartLabels[monthNumber - 1]
}

export function toDate(value) {
    if (value !== null && value !== undefined) {
        return moment(value).format('DD/MM/YYYY');
    } else {
        return null;
    }
};

export function toDateReqFormat(value) {
    if (value !== null && value !== undefined) {
        return moment(value).format('YYYY-MM-DD');
    } else {
        return null;
    }
};

export function toDateTime(value) {
    if (value !== null && value !== undefined) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss');
    } else {
        return null;
    }
};

export function toDateTimeNoSeconds(value) {
    if (value !== null && value !== undefined) {
        return moment(value).format('DD/MM/YYYY HH:mm');
    } else {
        return null;
    }
};

export function toDateTimeReqFormat(value) {
    if (value !== null && value !== undefined) {
        return moment(value).format('YYYY-MM-DD HH:mm:ss');
    } else {
        return null;
    }
};

export function toMonthYear(value) {
    if (value !== null && value !== undefined) {
        return moment(value).format('MM/YYYY');
    } else {
        return null;
    }
};

export function monthYearFormatt(monthYear, day) {
    var mes = monthYear.split("/")[0];
    var ano = monthYear.split("/")[1];

    return ano + '-' + ("0" + mes).slice(-2) + '-' + ("0" + day).slice(-2);
}

export function monthYearToDate(monthYear) {
    var data = "01/".concat(monthYear)
    var dia = data.split("/")[0];
    var mes = data.split("/")[1];
    var ano = data.split("/")[2];

    return ano + '-' + ("0" + mes).slice(-2) + '-' + ("0" + dia).slice(-2);
}

export function toFirstDay(value) {
    if (value !== null && value !== undefined) {
        let month = value.getMonth()
        let year = value.getFullYear()
        var date = new Date(year, month, 1);
        return moment(date).format('YYYY-MM-DD');
    } else {
        return null;
    }
};
export function toLastDay(value) {
    if (value !== null && value !== undefined) {
        let month = value.getMonth()
        let year = value.getFullYear()
        var date = new Date(year, month + 1, 0);
        return moment(date).format('YYYY-MM-DD');
    } else {
        return null;
    }
};

export function getMonthYearName(value) {
    const month_names = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    // const month_names_short = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Aug', 'Set', 'Out', 'Nov', 'Dez'];

    if (value !== null && value !== undefined) {
        return month_names[value.getMonth()].concat(' ' + moment(value).format('YYYY'))
    } else {
        return null;
    }
};

export function toYear(value) {
    if (value !== null && value !== undefined) {
        return moment(value).format('YYYY');
    } else {
        return null;
    }
};

export function formatDate(rangeLabel) {
    let year = Number(rangeLabel.substring(0, 4))
    let month = Number(rangeLabel.substring(5, 7))
    let day = Number(rangeLabel.substring(8, 10))
    return new Date(year, month - 1, day)
}

export function verifySameMonth(date, men) {
    return date.substring(5, 7) == ((men + 1).toString().padStart(2, "0"));
}


export function formatDateCompliance(value) {
    if (value === "0001-01-01T00:00:00") {
        return 'N/A'
    } else {
        return toDate(value);
    }
}

export function addDaysToDate(value, days) {
    const date = toDate(value);

    return moment(date, 'DD/MM/YYYY').add(days, 'days').format('DD/MM/YYYY');
}